export default function sendMessage(state) {
  const stringifiedMessageObj = JSON.stringify({ message: state });
  console.log(stringifiedMessageObj);
  if (window.webkit) {
    window.webkit.messageHandlers.cordova_iab.postMessage(
      stringifiedMessageObj
    );
  }
}
